/**
 * Legacy CouponsApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.couponsApi`) keep resolving.
 *
 * The actual CouponsApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/coupons/coupons-api.service.ts
 */
angular.module("acme.common.service.couponsApi", [
  "acme.common.factory.QueryStringBuilder",
]);
